/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="104.73"
        height="95.58"
        viewBox="0 0 104.73 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M99.11 86.82a1.25 1.25 0 0 1 .13 2.49H5.62a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h93.61ZM103.48 93.08a1.252 1.252 0 0 1 .13 2.5H1.25a1.25 1.25 0 0 1-.13-2.49h102.36Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M57.72 18.98a5.36 5.36 0 1 0-5.35 5.35 5.35 5.35 0 0 0 5.35-5.35"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M52.37 12.37A6.61 6.61 0 1 0 59 18.98a6.61 6.61 0 0 0-6.63-6.61Zm0 2.5a4.11 4.11 0 1 1-4.11 4.11 4.1 4.1 0 0 1 4.11-4.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M51.64.27 5 37.5a1.25 1.25 0 0 0 .78 2.23h93.37a1.25 1.25 0 0 0 .78-2.23L53.2.27a1.26 1.26 0 0 0-1.56 0Zm.78 2.58 43.12 34.33H9.31Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M77.47 30.92a1.25 1.25 0 0 1 .13 2.49H27.54a1.252 1.252 0 0 1-.13-2.5h50.06ZM23.4 42.04h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M15.2 45.98a1 1 0 0 1 1 .88V79.5a1 1 0 0 1-1 1 1 1 0 0 1-1-.88V46.98a1 1 0 0 1 1-1ZM22.62 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1ZM90.31 42.04h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M82.11 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1ZM89.54 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1ZM68.06 42.04h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M59.86 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1ZM67.29 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1ZM45.73 42.04h-9a3 3 0 1 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 1 1 0-1.94ZM23.4 78.5h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94ZM90.31 78.5h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M68.06 78.5h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 0 1 0-1.94ZM45.73 78.5h-9a3 3 0 1 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 0 1.94h-9a1 1 0 1 1 0-1.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M37.53 45.98a1 1 0 0 1 1 .88V79.5a1 1 0 0 1-1 1 1 1 0 0 1-1-.88V46.98a1 1 0 0 1 1-1ZM45 45.98a1 1 0 0 1 1 .88V79.5a1.002 1.002 0 0 1-2 .12V46.98a1 1 0 0 1 1-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FourRomanColumnsYellowRoofDotIcon';

export default Icon;
